import axios from 'axios';

export const getActiveAnnouncement = () => axios.get('/common/announcements/active/');
